import { useState } from "react";
import { UI_STYLES } from "@/styles/uiStyles";
import { SubscriptionPlanType } from "../SubscriptionScreenViewModel";
import { motion } from "framer-motion"; 

interface AutoContinuationModalContentProps {
  plan: SubscriptionPlanType;
  setIsAutoContinuationOpen: (isOpen: boolean) => void;
  onSuccessSelection: (isAutoContinuation: boolean) => void;
}

export const AutoContinuationModalContent = ({
  plan,
  setIsAutoContinuationOpen,
  onSuccessSelection,
}: AutoContinuationModalContentProps) => {
  const [isAutoContinuation, setIsAutoContinuation] = useState(false);

  const handleSuccessSelection = () => {
    onSuccessSelection(isAutoContinuation);
    setIsAutoContinuationOpen(false);
  };

  return (
    <div className="flex flex-col items-center justify-center w-full p-4 max-w-[400px] mx-auto ">
      <h2 className="text-white text-lg w-full text-start leading-relaxed  overflow-y-auto mb-4">
        Автоматическое продление подписки
      </h2>
      <div className="flex items-center justify-start  gap-2 mb-4">
        <div className="relative">
          <input
            id="auto-continuation"
            type="checkbox"
            className="w-4 h-4 border-white border-2 rounded-sm cursor-pointer opacity-0 absolute z-10"
            checked={isAutoContinuation}
            onChange={() => setIsAutoContinuation(!isAutoContinuation)}
          />
          <div 
            className={`w-4 h-4 border-white border-2 rounded-sm flex items-center justify-center ${
              isAutoContinuation ? 'bg-emerald-500 border-emerald-500' : 'bg-transparent'
            }`}
          >
            {isAutoContinuation && (
              <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
          </div>
        </div>
        <label htmlFor="auto-continuation" className="text-white text-base">
          Даю согласие на продление подписки на тот же срок, по ее завершению
        </label>
      </div>
      {isAutoContinuation && (
        <motion.div
          className="w-full overflow-hidden"
          initial={{ opacity: 0, y: 10, height: 0 }}
          animate={{ opacity: 1, y: 0, height: "auto" }}
          exit={{ opacity: 0, y: -10, height: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="text-white text-base leading-relaxed text-start mb-6 hide-scrollbar max-h-[300px] overflow-y-auto">
            Включив автопродление, вы соглашаетесь, что по окончании текущего
            оплаченного периода подписка будет автоматически продлеваться, а
            сумма{" "}
            <span className={`font-bold ${UI_STYLES.emeraldTextColor}`}>
              {plan.price}
            </span>{" "}
            будет списываться с вашего счета{" "}
            <span className={`font-bold ${UI_STYLES.emeraldTextColor}`}>
              {plan.description}
            </span>
            . Вы можете отключить автопродление в любой момент в настройках или
            написав нам письмо на почту
            <span className={`font-bold ${UI_STYLES.emeraldTextColor}`}>
              {" "}
              mir_zvezd@bk.ru
            </span>
            .
          </div>
        </motion.div>
      )}
      <button
        className={`w-full max-w-xs ${UI_STYLES.buttonGradient} hover:bg-cyan-700 text-white  rounded-xl py-3 mb-2 transition`}
        onClick={handleSuccessSelection}
      >
        Продолжить
      </button>
    </div>
  );
};
